import axios from "axios";
import fs from "fs";
import moment from "moment";
import { ConnectionError } from "../utils/errors";
import { getIni,getCajaStat, getCashbook, getCashbookComplete, getInstructorsList } from '../services'
//import { usuarioRef, sesionesRef, authRef } from "../config/firebase";
import { 
	LIMPIA_CAJA,
	TOAST_MSJ,
	LOG_USER,
	LOGOUT_USER,
	SEND_USER_MSJ,
	TOKEN_VENCIDO,
	CHK_USER,
	GET_ENQUIRIES,
	GET_ROOMS,
	GET_ROOMS_PRICES,
	GET_SEASONS,
	UPDATE_SEASONS,
	GET_CUSTOM_ITEMS,
	SET_CONTAINI,
	GET_CONTAINI,
	GET_DESTINATARIOS,
	GET_CASHBOOK,
	GET_INVENTARY,
	GET_CLIENTS,
	GET_SUPPLIERS,
	GET_ITEMS,
	GET_USUARIOS,
	GET_MEDIOS,
	GET_MONEDAS,
	GET_RUBROS,
	GET_SUBRUBROS,
	GET_SOURCE,
	GET_CUERPO,
	GET_TAXES,
	ADD_MOV,
	ADD_CLIENT,
	ADD_SUPPLIER,
	ADD_ITEM,
	ADD_USUARIO,
	ADD_MEDIO,
	ADD_MONEDA,
	ADD_RUBRO,
	ADD_SUBRUBRO,
	ADD_SOURCE,
	ADD_TAX,
	UPDATE_MOV,
	UPDATE_CLIENT,
	UPDATE_SUPPLIER,
	UPDATE_ITEM,
	UPDATE_USUARIO,
	UPDATE_MEDIO,
	UPDATE_MONEDA,
	UPDATE_RUBRO,
	UPDATE_SUBRUBRO,
	UPDATE_SOURCE,
	UPDATE_TAX,
	ADD_MOV_ITEM,
	ADD_MOV_PAGO,
	UPDATE_MOV_ITEM,
	UPDATE_MOV_PAGO,
	DEL_MOV_ITEM,
	DEL_MOV_PAGO,
	DEL_MOV,
	DEL_CLIENT,
	DEL_SUPPLIER,
	DEL_ITEM,
	DEL_MEDIO,
	DEL_MONEDA,
	DEL_RUBRO,
	DEL_SUBRUBRO,
	DEL_SOURCE,
	DEL_TAX,
	ADD_STOCK,
	GET_STOCK,
	GET_CAJA,
	GET_CAJA_MOVS,
	UPDATE_DATO,
	UPDATE_PRICE,
	CAMBIA_HOTEL_DEF,
	GET_HOTELES,
	GET_INFORME,
	GET_COMISIONES,
	GET_CALENDARIO,
	GET_EVENTOS,
	ADD_EVENTO,
	UPDATE_EVENTO,
	DEL_EVENTO,
	ADD_PARTICIPANTE,
	UPDATE_PARTICIPANTE,
	DEL_PARTICIPANTE,
	GET_DASHINI,
	GET_MEAN_PAYMENTS,
	GET_RESUMEN,
	GET_ACTIVITY_FORMATS,
	ADD_ACTIVITY_FORMATS,
	UPDATE_ACTIVITY_FORMATS,
	DEL_ACTIVITY_FORMATS,
	GET_ACTIVITIES,
	ADD_ACTIVITIES,
	UPDATE_ACTIVITIES,
	DEL_ACTIVITIES,
	GET_INSTRUCTORS,
	ADD_INSTRUCTORS,
	UPDATE_INSTRUCTORS,
	DEL_INSTRUCTORS,
	GET_ASSET,
	ADD_ASSET,
	UPDATE_ASSET,
	DEL_ASSET,
	GET_ASSETS_TYPE,
	ADD_ASSETS_TYPE,
	UPDATE_ASSETS_TYPE,
	DEL_ASSETS_TYPE,
	GET_BNUMBERS,
	ADD_BNUMBERS,
	UPDATE_BNUMBERS,
	GET_RECEIPTS,
	GET_YOGA,
	GET_HISTORIAL_CAJA,
	CHECK_CABECERA,
	CHECK_ITEM,
	GET_ENQUI_REPORT,
} from './constants'

/*
const api_url = "https://surfandyogacostarica.com:2979/";
const url_conta = "https://airnizer.com:2977/api/believe/";
*/

const api_url = process.env.REACT_APP_URL_BELIEVE
const url_conta = process.env.REACT_APP_URL_AIRNIZER

//const url_auth = api_url + "auth";
const url_enquiries = api_url + "enquiries";
const url_enquiries_report = api_url + "enquiries/report";
const url_seasons = api_url + "enquiries/seasons";
const url_customizer_items = api_url + "enquiries/customizer_items";
const url_rooms = api_url + "rooms";
const url_rooms_prices = api_url + "rooms/prices";
const url_auth = url_conta

export const cambiaHotel = async (id_hotel) =>{
	try {
		const id = parseInt(id_hotel, 10);
		localStorage.setItem("id_hotel", id);
		return {
			type: CAMBIA_HOTEL_DEF,
			payload: id,
		};
	} catch (error) {
		throw new ConnectionError(error)
	}
}

export const getEnquiReport = async (_desde,_hasta) =>{
	try {
		var axiosConfig = {
			headers: {
				Authorization: "Bearer " + localStorage.getItem("BelieveToken"),
			},
		};

		const datos = await axios.get(url_enquiries_report+"/"+_desde+"/"+_hasta, axiosConfig);

		if (datos.data.error && datos.data.hasOwnProperty("sale") && datos.data.sale == 1) await sale();
		
		var resp = {
			type: GET_ENQUI_REPORT,
			payload: datos.data.data,
		};
		//
		return resp;
	} catch (error) {
		throw new ConnectionError(error)
	}
}

export const getNumbers = async (term) =>{
	try {
		var axiosConfig = {
			headers: {
				Authorization: "Bearer " + localStorage.getItem("BelieveToken"),
			},
		};
		
		var bnumbers = await axios.get(url_conta + "b_numbers/"+term, axiosConfig);
		if (bnumbers.data.error && bnumbers.data.hasOwnProperty("sale") && bnumbers.data.sale == 1) await sale();
		
		return {
			type: GET_BNUMBERS,
			payload: bnumbers.data.data,
		};
	} catch (error) {
		throw new ConnectionError(error)
	}
}

export const addNumber = async (datos_send) => {
	try {
		var axiosConfig = {
			headers: {
				Authorization: "Bearer " + localStorage.getItem("BelieveToken"),
			},
		};
		var datos = await axios.post(url_conta + "b_numbers", datos_send, axiosConfig);
		
		if (datos.data.error && datos.data.hasOwnProperty("sale") && datos.data.sale == 1) await sale();
		const bnumbers_lista = await axios.get(url_conta + "b_numbers/", axiosConfig);
		var resp = {
			type: ADD_BNUMBERS,
			payload: bnumbers_lista.data.data,
			datos_send,
		};
		return resp;
	} catch (error) {
		throw new ConnectionError(error)
	}
};

export const updateNumber = async (datos_send) => {
	try {
		var axiosConfig = {
			headers: {
				Authorization: "Bearer " + localStorage.getItem("BelieveToken"),
			},
		};
		var datos = await axios.put(url_conta + "b_numbers/"+datos_send.id, datos_send, axiosConfig);
		
		if (datos.data.error && datos.data.hasOwnProperty("sale") && datos.data.sale == 1) await sale();
		const bnumbers_lista = await axios.get(url_conta + "b_numbers/", axiosConfig);
		var resp = {
			type: UPDATE_BNUMBERS,
			payload: bnumbers_lista.data.data,
			datos_send,
		};
		return resp;
	} catch (error) {
		throw new ConnectionError(error)
	}
};



export const getHistorialCaja = async (_id_hotel,_desde,_hasta) =>{
	try {
		var axiosConfig = {
			headers: {
				Authorization: "Bearer " + localStorage.getItem("BelieveToken"),
			},
		};
		var h = await axios.get(url_conta + "historial_cierreapertura/"+_id_hotel+"/"+_desde+"/"+_hasta, axiosConfig);
		if (h.data.error && h.data.hasOwnProperty("sale") && h.data.sale == 1) await sale();
		return {
			type: GET_HISTORIAL_CAJA,
			payload: h.data.data,
		};
	} catch (error) {
		throw new ConnectionError(error)
	}
}

export const getComisiones = async () =>{
	try {
		var axiosConfig = {
			headers: {
				Authorization: "Bearer " + localStorage.getItem("BelieveToken"),
			},
		};
		var h = await axios.get(url_conta + "comisiones", axiosConfig);
		if (h.data.error && h.data.hasOwnProperty("sale") && h.data.sale == 1) await sale();
		return {
			type: GET_COMISIONES,
			payload: h.data.data,
		};
	} catch (error) {
		throw new ConnectionError(error)
	}
}

export const getResumen = async (id_hotel,desde,hasta) =>{
	try {
		var axiosConfig = {
			headers: {
				Authorization: "Bearer " + localStorage.getItem("BelieveToken"),
			},
		};
		var h = await axios.get(url_conta + "resumen/"+id_hotel+"/"+desde+"/"+hasta+"/1", axiosConfig);
		if (h.data.error && h.data.hasOwnProperty("sale") && h.data.sale == 1) await sale();
		return {
			type: GET_RESUMEN,
			payload: h.data,
		};
	} catch (error) {
		throw new ConnectionError(error)
	}
}

export const getYoga = async (id_hotel,desde,hasta) =>{
	try {
		var axiosConfig = {
			headers: {
				Authorization: "Bearer " + localStorage.getItem("BelieveToken"),
			},
		};
		var h = await axios.get(url_conta + "yoga/"+id_hotel+"/"+desde+"/"+hasta, axiosConfig);
		if (h.data.error && h.data.hasOwnProperty("sale") && h.data.sale == 1) await sale();
		return {
			type: GET_YOGA,
			payload: h.data.data,
		};
	} catch (error) {
		throw new ConnectionError(error)
	}
}

export const getMeanPayments = async (desde, hasta) =>{
	try {
		var axiosConfig = {
			headers: {
				Authorization: "Bearer " + localStorage.getItem("BelieveToken"),
			},
		};
		var h = await axios.get(url_conta + "mean_payments/"+desde+"/"+hasta, axiosConfig);
		if (h.data.error && h.data.hasOwnProperty("sale") && h.data.sale == 1) await sale();
		
		return {
			type: GET_MEAN_PAYMENTS,
			payload: h.data.data,
		};
	} catch (error) {
		throw new ConnectionError(error)
	}
}


export const getHoteles = async () =>{
	try {
		var axiosConfig = {
			headers: {
				Authorization: "Bearer " + localStorage.getItem("BelieveToken"),
			},
		};
		var h = await axios.get(url_conta + "hoteles", axiosConfig);
		if (h.data.error && h.data.hasOwnProperty("sale") && h.data.sale == 1) await sale();
		return {
			type: GET_HOTELES,
			payload: h.data.data,
		};
	} catch (error) {
		throw new ConnectionError(error)
	}
}

export const getInforme = async (id_hotel,desde,hasta) =>{
	try {
		var axiosConfig = {
			headers: {
				Authorization: "Bearer " + localStorage.getItem("BelieveToken"),
			},
		};
		
		var informe = await axios.get(url_conta + "informe/"+id_hotel+"/"+desde+"/"+hasta, axiosConfig);
		if (informe.data.error && informe.data.hasOwnProperty("sale") && informe.data.sale == 1) await sale();
		
		return {
			type: GET_INFORME,
			payload: informe.data,
		};
	} catch (error) {
		throw new ConnectionError(error)
	}
}

export const getCalendario = async (id_hotel,desde,hasta,id_tipo) =>{
	try {
		var axiosConfig = {
			headers: {
				Authorization: "Bearer " + localStorage.getItem("BelieveToken"),
			},
		};
		
		var tipo = (id_tipo>0)?"/"+id_tipo:""
		var calendario = await axios.get(url_conta + "calendario/"+id_hotel+"/"+desde+"/"+hasta+tipo, axiosConfig);
		if (calendario.data.error && calendario.data.hasOwnProperty("sale") && calendario.data.sale == 1) await sale();
		
		return {
			type: GET_CALENDARIO,
			payload: calendario.data.data,
		};
	} catch (error) {
		throw new ConnectionError(error)
	}
}

export const addCalendario = async (datos_send) => {
	try {
		var axiosConfig = {
			headers: {
				Authorization: "Bearer " + localStorage.getItem("BelieveToken"),
			},
		};
		var datos = await axios.post(url_conta + "calendario", datos_send, axiosConfig);
		
		if (datos.data.error && datos.data.hasOwnProperty("sale") && datos.data.sale == 1) await sale();
		var resp = {
			type: ADD_EVENTO,
			payload: datos,
			datos_send,
		};
		return resp;
	} catch (error) {
		throw new ConnectionError(error)
	}
};

export const updateCalendario = async (datos_send) => {
	try {
		var axiosConfig = {
			headers: {
				Authorization: "Bearer " + localStorage.getItem("BelieveToken"),
			},
		};
		var datos = await axios.put(url_conta + "calendario/"+datos_send.id, datos_send, axiosConfig);
		
		if (datos.data.error && datos.data.hasOwnProperty("sale") && datos.data.sale == 1) await sale();
		var resp = {
			type: UPDATE_EVENTO,
			payload: datos,
			datos_send,
		};
		return resp;
	} catch (error) {
		throw new ConnectionError(error)
	}
};

export const getEventos = async (id_hotel,desde,hasta,id_tipo) =>{
	try {
		
		var axiosConfig = {
			headers: {
				Authorization: "Bearer " + localStorage.getItem("BelieveToken"),
			},
		};
		
		var tipo = (id_tipo>0)?"/"+id_tipo:""
		var eventos = await axios.get(url_conta + "eventos/"+id_hotel+"/"+desde+"/"+hasta+tipo, axiosConfig);
		if (eventos.data.error && eventos.data.hasOwnProperty("sale") && eventos.data.sale == 1) await sale();
		
		return {
			type: GET_EVENTOS,
			payload: eventos.data.data,
		};
	} catch (error) {
		throw new ConnectionError(error)
	}
}

export const addEvento = async (datos_send) => {
	try {
		var axiosConfig = {
			headers: {
				Authorization: "Bearer " + localStorage.getItem("BelieveToken"),
			},
		};
		var datos = await axios.post(url_conta + "evento", datos_send, axiosConfig);
		
		if (datos.data.error && datos.data.hasOwnProperty("sale") && datos.data.sale == 1) await sale();
		var resp = {
			type: ADD_EVENTO,
			payload: datos,
			datos_send,
		};
		return resp;
	} catch (error) {
		throw new ConnectionError(error)
	}
};

export const updateEvento = async (datos_send) => {
	try {
		var axiosConfig = {
			headers: {
				Authorization: "Bearer " + localStorage.getItem("BelieveToken"),
			},
		};
		var datos = await axios.put(url_conta + "evento/"+datos_send.id, datos_send, axiosConfig);
		if (datos.data.error && datos.data.hasOwnProperty("sale") && datos.data.sale == 1) await sale();
		var resp = {
			type: UPDATE_EVENTO,
			payload: datos,
			datos_send,
		};
		return resp;
	} catch (error) {
		throw new ConnectionError(error)
	}
};

export const delEvento = async (id) => {
	try {
		var axiosConfig = {
			headers: {
				Authorization: "Bearer " + localStorage.getItem("BelieveToken"),
			},
		};
		var datos = await axios.delete(url_conta + "evento/"+id, axiosConfig);
		if (datos.data.error && datos.data.hasOwnProperty("sale") && datos.data.sale == 1) await sale();
		var resp = {
			type: DEL_EVENTO,
			payload: id,
		};
		return resp;
	} catch (error) {
		throw new ConnectionError(error)
	}
};
 /*
export const addParticipante = async (datos_send) => {
	try {
		var axiosConfig = {
			headers: {
				Authorization: "Bearer " + localStorage.getItem("BelieveToken"),
			},
		};
		var datos = await axios.post(url_conta + "calendario_participante", datos_send, axiosConfig);
		
		if (datos.data.error && datos.data.hasOwnProperty("sale") && datos.data.sale == 1) await sale();
		var resp = {
			type: ADD_PARTICIPANTE,
			payload: datos,
			datos_send,
		};
		return resp;
	} catch (error) {
		throw new ConnectionError(error)
	}
};

export const delParticipante = async (id) => {
	try {
		var axiosConfig = {
			headers: {
				Authorization: "Bearer " + localStorage.getItem("BelieveToken"),
			},
		};
		var datos = await axios.delete(url_conta + "calendario_participante/"+id, axiosConfig);
		
		if (datos.data.error && datos.data.hasOwnProperty("sale") && datos.data.sale == 1) await sale();
		var resp = {
			type: DEL_PARTICIPANTE,
			payload: datos,
		};
		return resp;
	} catch (error) {
		throw new ConnectionError(error)
	}
};
*/

export const getCaja = async (id_usuario,id_hotel) =>{
	try {
		var axiosConfig = {
			headers: {
				Authorization: "Bearer " + localStorage.getItem("BelieveToken"),
			},
		};
		console.log("getCaja")
		const caja = await getCajaStat(id_hotel)
		//var caja = await axios.get(url_conta + "caja_stat_new/"+id_hotel, axiosConfig);
		if (caja.data.error && caja.data.hasOwnProperty("sale") && caja.data.sale == 1) await sale();
		return {
			type: GET_CAJA,
			payload: caja.data.data,
			movs: caja.data.movs,
			movs_cash: caja.data.movs_cash,
		};
	} catch (error) {
		throw new ConnectionError(error)
	}
}

export const getCajaMovs = async (id_usuario,id_hotel,desde,hasta) =>{
	try {
		var axiosConfig = {
			headers: {
				Authorization: "Bearer " + localStorage.getItem("BelieveToken"),
			},
		};
		var caja = await axios.get(url_conta + "caja_movs/"+id_hotel+"/"+id_usuario+"/"+desde+"/"+hasta, axiosConfig);
		if (caja.data.error && caja.data.hasOwnProperty("sale") && caja.data.sale == 1) await sale();
		return {
			type: GET_CAJA_MOVS,
			payload: caja.data.data,
		};
	} catch (error) {
		throw new ConnectionError(error)
	}
}

export const getStock = async () => {
	try {
		var axiosConfig = {
			headers: {
				Authorization: "Bearer " + localStorage.getItem("BelieveToken"),
			},
		};
		var cashmovs = await axios.get(url_conta + "mov_stock", axiosConfig);
		if (cashmovs.data.error && cashmovs.data.hasOwnProperty("sale") && cashmovs.data.sale == 1) await sale();
		return {
			type: GET_STOCK,
			payload: cashmovs.data.data,
		};
	} catch (error) {
		throw new ConnectionError(error)
	}
};

export const addStock = async (mov) => {
	try {
		var axiosConfig = {
			headers: {
				Authorization: "Bearer " + localStorage.getItem("BelieveToken"),
			},
		};
		const datos = await axios.post(url_conta+"mov_stock",mov, axiosConfig);
		var stockmovs = await axios.get(url_conta + "mov_stock", axiosConfig);
		if (datos.data.error && datos.data.hasOwnProperty("sale") && datos.data.sale == 1) await sale();
		
		return{
			type: ADD_STOCK,
			payload: stockmovs.data.data,
			mov
		};
	} catch (error) {
		throw new ConnectionError(error)
	}
};

export const addMov = async (mov,desde,hasta,id_hotel) => {
	try {
		var axiosConfig = {
			headers: {
				Authorization: "Bearer " + localStorage.getItem("BelieveToken"),
			},
		};
		const datos = await axios.post(url_conta+"movs",mov, axiosConfig);

		const cashmovs = await getCashbook(desde,hasta,id_hotel)
		const caja = await getCajaStat(id_hotel)

		//var cashmovs = await axios.get(url_conta + "cashbook/"+desde+"/"+hasta+"/"+id_hotel, axiosConfig);
		//var caja = await axios.get(url_conta + "caja_stat_new/"+mov.id_hotel, axiosConfig);
		
		if (datos.data.error && datos.data.hasOwnProperty("sale") && datos.data.sale == 1) await sale();
		
		var resp = {
			type: ADD_MOV,
			payload: cashmovs.data.data,
			caja:caja.data.data,
			caja_movs:caja.data.movs,
			caja_movs_cash:caja.data.movs_cash
		};
		return resp;
	} catch (error) {
		throw new ConnectionError(error)
	}
};

export const getCash = async (desde,hasta,id_hotel) => {
	try {
		let axiosConfig = {
			headers: {
				Authorization: "Bearer " + localStorage.getItem("BelieveToken"),
			},
		};
		console.log("GetCash")
		const cashmovs = await getCashbookComplete(desde,hasta,id_hotel)
		const caja = await getCajaStat(id_hotel)
		//let cashmovs = await axios.get(url_conta + "cashbook/"+desde+"/"+hasta+"/"+id_hotel, axiosConfig);
		//let caja = await axios.get(url_conta + "caja_stat_new/"+id_hotel, axiosConfig);
		if (cashmovs.data.error && cashmovs.data.hasOwnProperty("sale") && cashmovs.data.sale == 1) await sale();
		
		let resp = {
			type: GET_CASHBOOK,
			payload: cashmovs.data.data,
			caja:caja.data.data,
			caja_movs:caja.data.movs
		};
		return resp;
	} catch (error) {
		throw new ConnectionError(error)
	}
};

export const traeCuerpoMov = async (id) => {
	try {
		var axiosConfig = {
			headers: {
				Authorization: "Bearer " + localStorage.getItem("BelieveToken"),
			},
		};
		const cuerpo = await axios.get(url_conta+"mov/"+id, axiosConfig);

		if (cuerpo.data.error && cuerpo.data.hasOwnProperty("sale") && cuerpo.data.sale == 1) await sale();
		
		var resp = {
			type: GET_CUERPO,
			payload: cuerpo.data,
		};
		return resp;
	} catch (error) {
		throw new ConnectionError(error)
	}
}

export const updateMov = async (datos_send,desde,hasta,id_hotel) => {
	try {
		var axiosConfig = {
			headers: {
				Authorization: "Bearer " + localStorage.getItem("BelieveToken"),
			},
		};
		var datos = await axios.put(url_conta + "movs_cabecera/"+datos_send.id_cabecera, datos_send, axiosConfig);
		//var cashmovs = await axios.get(url_conta + "cashbook/"+desde+"/"+hasta+"/"+id_hotel, axiosConfig);
		//var caja = await axios.get(url_conta + "caja_stat_new/"+id_hotel, axiosConfig);
		const cashmovs = await getCashbook(desde,hasta,id_hotel)
		const caja = await getCajaStat(id_hotel)
		
		if (datos.data.error && datos.data.hasOwnProperty("sale") && datos.data.sale == 1) await sale();
		var resp = {
			type: UPDATE_MOV,
			payload: cashmovs.data.data,
			datos_send,
			caja:caja.data.data,
			caja_movs:caja.data.movs,
			caja_movs_cash:caja.data.movs_cash
		};
		return resp;
	} catch (error) {
		throw new ConnectionError(error)
	}
};

export const addMovItem = async (datos_send,id_cabecera,desde,hasta,id_hotel) => {
	try {
		var axiosConfig = {
			headers: {
				Authorization: "Bearer " + localStorage.getItem("BelieveToken"),
			},
		};
		const datos = await axios.post(url_conta + "movs_item",datos_send, axiosConfig);
		const add_item_cuerpo = await axios.get(url_conta+"mov/"+id_cabecera, axiosConfig);
		//var cashmovs = await axios.get(url_conta + "cashbook/"+desde+"/"+hasta+"/"+id_hotel, axiosConfig);
		//var caja = await axios.get(url_conta + "caja_stat_new/"+id_hotel, axiosConfig);
		const cashmovs = await getCashbook(desde,hasta,id_hotel)
		const caja = await getCajaStat(id_hotel)
		
		if (datos.data.error && datos.data.hasOwnProperty("sale") && datos.data.sale == 1) await sale();
		var resp = {
			type: ADD_MOV_ITEM,
			payload: cashmovs.data.data,
			payload_cuerpo:add_item_cuerpo.data.items,
			datos_send,
			caja:caja.data.data,
			caja_movs:caja.data.movs,
			caja_movs_cash:caja.data.movs_cash
		};
		return resp;
	} catch (error) {
		throw new ConnectionError(error)
	}
};

export const addMovPago = async (datos_send,id_cabecera,desde,hasta,id_hotel) => {
	try {
		var axiosConfig = {
			headers: {
				Authorization: "Bearer " + localStorage.getItem("BelieveToken"),
			},
		};
		const datos = await axios.post(url_conta + "movs_pago",datos_send, axiosConfig);
		const add_pago_cuerpo = await axios.get(url_conta+"mov/"+id_cabecera, axiosConfig);
		//var cashmovs = await axios.get(url_conta + "cashbook/"+desde+"/"+hasta+"/"+id_hotel, axiosConfig);
		//var caja = await axios.get(url_conta + "caja_stat_new/"+id_hotel, axiosConfig);
		const cashmovs = await getCashbook(desde,hasta,id_hotel)
		const caja = await getCajaStat(id_hotel)
		
		if (datos.data.error && datos.data.hasOwnProperty("sale") && datos.data.sale == 1) await sale();
		var resp = {
			type: ADD_MOV_PAGO,
			payload: cashmovs.data.data,
			payload_cuerpo:add_pago_cuerpo.data.pagos,
			datos_send,
			caja:caja.data.data,
			caja_movs:caja.data.movs,
			caja_movs_cash:caja.data.movs_cash
		};
		return resp;
	} catch (error) {
		throw new ConnectionError(error)
	}
};

export const updateMovItem = async (datos_send,desde,hasta,id_hotel) => {
	try {
		var axiosConfig = {
			headers: {
				Authorization: "Bearer " + localStorage.getItem("BelieveToken"),
			},
		};
		const datos = await axios.put(url_conta + "movs_item/"+datos_send.id, datos_send, axiosConfig);
		var cashmovs = await axios.get(url_conta + "cashbook/"+desde+"/"+hasta+"/"+id_hotel, axiosConfig);
		
		if (datos.data.error && datos.data.hasOwnProperty("sale") && datos.data.sale == 1) await sale();
		var resp = {
			type: UPDATE_MOV_ITEM,
			payload: cashmovs.data.data,
			datos_send,
		};
		return resp;
	} catch (error) {
		throw new ConnectionError(error)
	}
};

export const updateMovPago = async (datos_send,desde,hasta,id_hotel) => {
	try {
		var axiosConfig = {
			headers: {
				Authorization: "Bearer " + localStorage.getItem("BelieveToken"),
			},
		};
		const datos = await axios.put(url_conta + "movs_pago/"+datos_send.id, datos_send, axiosConfig);
		var cashmovs = await axios.get(url_conta + "cashbook/"+desde+"/"+hasta+"/"+id_hotel, axiosConfig);
		
		if (datos.data.error && datos.data.hasOwnProperty("sale") && datos.data.sale == 1) await sale();
		var resp = {
			type: UPDATE_MOV_PAGO,
			payload: cashmovs.data.data,
			datos_send,
		};
		return resp;
	} catch (error) {
		throw new ConnectionError(error)
	}
};

export const delMov = async (id,desde,hasta,id_hotel) => {
	try {
		var axiosConfig = {
			headers: {
				Authorization: "Bearer " + localStorage.getItem("BelieveToken"),
			},
		};
		const datos = await axios.delete(url_conta + "movs_cabecera/" + id,  axiosConfig);
		//var cashmovs = await axios.get(url_conta + "cashbook/"+desde+"/"+hasta+"/"+id_hotel, axiosConfig);
		//var caja = await axios.get(url_conta + "caja_stat_new/"+id_hotel, axiosConfig);
		const cashmovs = await getCashbook(desde,hasta,id_hotel)
		const caja = await getCajaStat(id_hotel)
		
		if (datos.data.error && datos.data.hasOwnProperty("sale") && datos.data.sale == 1) await sale();
		var resp = {
			type: DEL_MOV,
			payload: cashmovs.data.data,
			id,
			caja:caja.data.data,
			caja_movs:caja.data.movs,
			caja_movs_cash:caja.data.movs_cash
		};
		return resp;
	} catch (error) {
		throw new ConnectionError(error)
	}
};

export const delMovItem = async (id,desde,hasta,id_hotel) => {
	try {
		var axiosConfig = {
			headers: {
				Authorization: "Bearer " + localStorage.getItem("BelieveToken"),
			},
		};
		const datos = await axios.delete(url_conta + "movs_item/" + id,  axiosConfig);
		//var cashmovs = await axios.get(url_conta + "cashbook/"+desde+"/"+hasta+"/"+id_hotel, axiosConfig);
		//var caja = await axios.get(url_conta + "caja_stat_new/"+id_hotel, axiosConfig);
		const cashmovs = await getCashbook(desde,hasta,id_hotel)
		const caja = await getCajaStat(id_hotel)
		
		if (datos.data.error && datos.data.hasOwnProperty("sale") && datos.data.sale == 1) await sale();
		var resp = {
			type: DEL_MOV_ITEM,
			payload: cashmovs.data.data,
			id,
			caja:caja.data.data,
			caja_movs:caja.data.movs,
			caja_movs_cash:caja.data.movs_cash
		};
		return resp;
	} catch (error) {
		throw new ConnectionError(error)
	}
};

export const delMovPago = async (id,desde,hasta,id_hotel) => {
	try {
		var axiosConfig = {
			headers: {
				Authorization: "Bearer " + localStorage.getItem("BelieveToken"),
			},
		};
		const datos = await axios.delete(url_conta + "movs_pago/" + id,  axiosConfig);
		//var cashmovs = await axios.get(url_conta + "cashbook/"+desde+"/"+hasta+"/"+id_hotel, axiosConfig);
		//var caja = await axios.get(url_conta + "caja_stat_new/"+id_hotel, axiosConfig);
		const cashmovs = await getCashbook(desde,hasta,id_hotel)
		const caja = await getCajaStat(id_hotel)
		
		if (datos.data.error && datos.data.hasOwnProperty("sale") && datos.data.sale == 1) await sale();
		var resp = {
			type: DEL_MOV_PAGO,
			payload: cashmovs.data.data,
			id,
			caja:caja.data.data,
			caja_movs:caja.data.movs,
			caja_movs_cash:caja.data.movs_cash
		};
		return resp;
	} catch (error) {
		throw new ConnectionError(error)
	}
};

export const getInventary = async (mes,ano) => {
	try {
		var axiosConfig = {
			headers: {
				Authorization: "Bearer " + localStorage.getItem("BelieveToken"),
			},
		};
		const datos = await axios.get(url_conta + "inventary/"+mes+"/"+ano, axiosConfig);
		if (datos.data.error && datos.data.hasOwnProperty("sale") && datos.data.sale == 1) await sale();
		
		var resp = {
			type: GET_INVENTARY,
			payload: datos.data.data,
		};
		return resp;
	} catch (error) {
		throw new ConnectionError(error)
	}
};

export const getDashIni = async () => {
	try {
		/*var axiosConfig = {
			headers: {
				Authorization: "Bearer " + localStorage.getItem("BelieveToken"),
			},
		};*/
		//const datos = await axios.get(url_conta+"conta_ini", axiosConfig);
		const datos = await getIni()
		if (datos.data.error && datos.data.hasOwnProperty("sale") && datos.data.sale == 1) await sale();
		var resp = {
			type: GET_DASHINI,
			payload: datos.data
		};
		return resp;
	} catch (error) {
		throw new ConnectionError(error)
	}
};

export const getCashbookIni = async (desde,hasta,id_hotel) => {
	try {
		var axiosConfig = {
			headers: {
				Authorization: "Bearer " + localStorage.getItem("BelieveToken"),
			},
		};
		console.log("getCashbookIni")
		//const datos = await axios.get(url_conta+"conta_ini", axiosConfig);
		
		const datos = await getIni()
		const cashmovs = await getCashbookComplete(desde,hasta,id_hotel)
		const caja = await getCajaStat(id_hotel)

		//var cashmovs = await axios.get(url_conta + "cashbook/"+desde+"/"+hasta+"/"+id_hotel, axiosConfig);
		//var caja = await axios.get(url_conta + "caja_stat_new/"+id_hotel, axiosConfig);

		if (datos.data.error && datos.data.hasOwnProperty("sale") && datos.data.sale == 1) await sale();
		
		let resp = {
			type: GET_CONTAINI,
			payload: datos.data,
			movs: cashmovs.data.data,
			caja:caja.data.data,
			caja_movs:caja.data.movs,
			caja_movs_cash:caja.data.movs_cash
		};
		return resp;
	} catch (error) {
		throw new ConnectionError(error)
	}
};

export const getSource = async () => {
	try {
		var axiosConfig = {
			headers: {
				Authorization: "Bearer " + localStorage.getItem("BelieveToken"),
			},
		};
		const datos = await axios.get(url_conta + "sources", axiosConfig);
		if (datos.data.error && datos.data.hasOwnProperty("sale") && datos.data.sale == 1) await sale();
		var resp = {
			type: GET_SOURCE,
			payload: datos.data.data,
		};
		return resp;
	} catch (error) {
		throw new ConnectionError(error)
	}
};

export const getClients = async () => {
	try {
		var axiosConfig = {
			headers: {
				Authorization: "Bearer " + localStorage.getItem("BelieveToken"),
			},
		};
		const datos = await axios.get(url_conta + "clients", axiosConfig);
		if (datos.data.error && datos.data.hasOwnProperty("sale") && datos.data.sale == 1) await sale();
		var resp = {
			type: GET_CLIENTS,
			payload: datos.data.data,
		};
		return resp;
	} catch (error) {
		throw new ConnectionError(error)
	}
};

export const getSuppliers = async () => {
	try {
		var axiosConfig = {
			headers: {
				Authorization: "Bearer " + localStorage.getItem("BelieveToken"),
			},
		};
		const datos = await axios.get(url_conta + "suppliers", axiosConfig);
		if (datos.data.error && datos.data.hasOwnProperty("sale") && datos.data.sale == 1) await sale();
		var resp = {
			type: GET_SUPPLIERS,
			payload: datos.data.data,
		};
		return resp;
	} catch (error) {
		throw new ConnectionError(error)
	}
};

export const getItems = async () => {
	try {
		var axiosConfig = {
			headers: {
				Authorization: "Bearer " + localStorage.getItem("BelieveToken"),
			},
		};
		const datos = await axios.get(url_conta + "products", axiosConfig);
		if (datos.data.error && datos.data.hasOwnProperty("sale") && datos.data.sale == 1) await sale();
		var resp = {
			type: GET_ITEMS,
			payload: datos.data.data,
		};
		return resp;
	} catch (error) {
		throw new ConnectionError(error)
	}
};

export const getUsuarios = async () => {
	try {
		var axiosConfig = {
			headers: {
				Authorization: "Bearer " + localStorage.getItem("BelieveToken"),
			},
		};
		const datos = await axios.get(url_conta + "usuarios", axiosConfig);
		if (datos.data.error && datos.data.hasOwnProperty("sale") && datos.data.sale == 1) await sale();
		var resp = {
			type: GET_USUARIOS,
			payload: datos.data.data,
		};
		return resp;
	} catch (error) {
		throw new ConnectionError(error)
	}
};

export const getMedios = async () => {
	try {
		var axiosConfig = {
			headers: {
				Authorization: "Bearer " + localStorage.getItem("BelieveToken"),
			},
		};
		const datos = await axios.get(url_conta + "medios", axiosConfig);
		if (datos.data.error && datos.data.hasOwnProperty("sale") && datos.data.sale == 1) await sale();
		var resp = {
			type: GET_MEDIOS,
			payload: datos.data.data,
		};
		return resp;
	} catch (error) {
		throw new ConnectionError(error)
	}
};

export const getMonedas = async () => {
	try {
		var axiosConfig = {
			headers: {
				Authorization: "Bearer " + localStorage.getItem("BelieveToken"),
			},
		};
		const datos = await axios.get(url_conta + "monedas", axiosConfig);
		if (datos.data.error && datos.data.hasOwnProperty("sale") && datos.data.sale == 1) await sale();
		var resp = {
			type: GET_MONEDAS,
			payload: datos.data.data,
		};
		return resp;
	} catch (error) {
		throw new ConnectionError(error)
	}
};

export const getRubros = async () => {
	try {
		var axiosConfig = {
			headers: {
				Authorization: "Bearer " + localStorage.getItem("BelieveToken"),
			},
		};
		const datos = await axios.get(url_conta + "rubros", axiosConfig);
		if (datos.data.error && datos.data.hasOwnProperty("sale") && datos.data.sale == 1) await sale();
		var resp = {
			type: GET_RUBROS,
			payload: datos.data.data,
		};
		return resp;
	} catch (error) {
		throw new ConnectionError(error)
	}
};

export const getSubRubros = async () => {
	try {
		var axiosConfig = {
			headers: {
				Authorization: "Bearer " + localStorage.getItem("BelieveToken"),
			},
		};
		const datos = await axios.get(url_conta + "subrubros", axiosConfig);
		if (datos.data.error && datos.data.hasOwnProperty("sale") && datos.data.sale == 1) await sale();
		var resp = {
			type: GET_SUBRUBROS,
			payload: datos.data.data,
		};
		return resp;
	} catch (error) {
		throw new ConnectionError(error)
	}
};

export const getTaxes = async () => {
	try {
		var axiosConfig = {
			headers: {
				Authorization: "Bearer " + localStorage.getItem("BelieveToken"),
			},
		};
		const datos = await axios.get(url_conta + "taxes", axiosConfig);
		if (datos.data.error && datos.data.hasOwnProperty("sale") && datos.data.sale == 1) await sale();
		var resp = {
			type: GET_TAXES,
			payload: datos.data.data,
		};
		return resp;
	} catch (error) {
		throw new ConnectionError(error)
	}
};

export const addSource = async (datos_send) => {
	try {
		var axiosConfig = {
			headers: {
				Authorization: "Bearer " + localStorage.getItem("BelieveToken"),
			},
		};
		const datos = await axios.post(url_conta + "source",datos_send, axiosConfig);
		
		if (datos.data.error && datos.data.hasOwnProperty("sale") && datos.data.sale == 1) await sale();
		var resp = {
			type: ADD_SOURCE,
			payload: datos.data,
			datos_send,
		};
		return resp;
	} catch (error) {
		throw new ConnectionError(error)
	}
};

export const addClient = async (datos_send) => {
	try {
		var axiosConfig = {
			headers: {
				Authorization: "Bearer " + localStorage.getItem("BelieveToken"),
			},
		};
		const datos = await axios.post(url_conta + "clients",datos_send, axiosConfig);
		
		if (datos.data.error && datos.data.hasOwnProperty("sale") && datos.data.sale == 1) await sale();
		var resp = {
			type: ADD_CLIENT,
			payload: datos.data,
			datos_send,
		};
		return resp;
	} catch (error) {
		throw new ConnectionError(error)
	}
};

export const addSupplier = async (datos_send) => {
	try {
		var axiosConfig = {
			headers: {
				Authorization: "Bearer " + localStorage.getItem("BelieveToken"),
			},
		};
		const datos = await axios.post(url_conta + "suppliers", datos_send, axiosConfig);
		
		if (datos.data.error && datos.data.hasOwnProperty("sale") && datos.data.sale == 1) await sale();
		var resp = {
			type: ADD_SUPPLIER,
			payload: datos.data,
			datos_send,
		};
		return resp;
	} catch (error) {
		throw new ConnectionError(error)
	}
};

export const addItem = async (datos_send) => {
	try {
		var axiosConfig = {
			headers: {
				Authorization: "Bearer " + localStorage.getItem("BelieveToken"),
			},
		};
		const datos = await axios.post(url_conta + "products", datos_send, axiosConfig);
		
		if (datos.data.error && datos.data.hasOwnProperty("sale") && datos.data.sale == 1) await sale();
		const datos_lista = await axios.get(url_conta + "products", axiosConfig);
		var resp = {
			type: ADD_ITEM,
			payload: datos.data,
			datos_lista,
		};
		return resp;
	} catch (error) {
		throw new ConnectionError(error)
	}
};

export const addUsuario = async (datos_send) => {
	try {
		var axiosConfig = {
			headers: {
				Authorization: "Bearer " + localStorage.getItem("BelieveToken"),
			},
		};
		const datos = await axios.post(url_conta + "usuarios", datos_send, axiosConfig);
		
		if (datos.data.error && datos.data.hasOwnProperty("sale") && datos.data.sale == 1) await sale();
		const datos_lista = await axios.get(url_conta + "usuarios", axiosConfig);
		var resp = {
			type: ADD_USUARIO,
			payload: datos_lista.data.data,
			datos_send,
		};
		return resp;
	} catch (error) {
		throw new ConnectionError(error)
	}
};

export const addMedio = async (datos_send) => {
	try {
		var axiosConfig = {
			headers: {
				Authorization: "Bearer " + localStorage.getItem("BelieveToken"),
			},
		};
		const datos = await axios.post(url_conta + "medios", datos_send, axiosConfig);
		
		if (datos.data.error && datos.data.hasOwnProperty("sale") && datos.data.sale == 1) await sale();
		var resp = {
			type: ADD_MEDIO,
			payload: datos.data,
			datos_send,
		};
		return resp;
	} catch (error) {
		throw new ConnectionError(error)
	}
};

export const addMoneda = async (datos_send) => {
	try {
		var axiosConfig = {
			headers: {
				Authorization: "Bearer " + localStorage.getItem("BelieveToken"),
			},
		};
		const datos = await axios.post(url_conta + "monedas", datos_send, axiosConfig);
		
		if (datos.data.error && datos.data.hasOwnProperty("sale") && datos.data.sale == 1) await sale();
		var resp = {
			type: ADD_MONEDA,
			payload: datos.data,
			datos_send,
		};
		return resp;
	} catch (error) {
		throw new ConnectionError(error)
	}
};

export const addRubro = async (datos_send) => {
	try {
		var axiosConfig = {
			headers: {
				Authorization: "Bearer " + localStorage.getItem("BelieveToken"),
			},
		};
		const datos = await axios.post(url_conta + "rubros", datos_send, axiosConfig);
		
		if (datos.data.error && datos.data.hasOwnProperty("sale") && datos.data.sale == 1) await sale();
		const datos_lista = await axios.get(url_conta + "rubros", axiosConfig);
		var resp = {
			type: ADD_RUBRO,
			payload: datos.data,
			datos_send,
			datos_lista
		};
		return resp;
	} catch (error) {
		throw new ConnectionError(error)
	}
};

export const addSubRubro = async (datos_send) => {
	try {
		var axiosConfig = {
			headers: {
				Authorization: "Bearer " + localStorage.getItem("BelieveToken"),
			},
		};
		const datos = await axios.post(url_conta + "subrubros", datos_send, axiosConfig);
		
		if (datos.data.error && datos.data.hasOwnProperty("sale") && datos.data.sale == 1) await sale();
		const datos_lista = await axios.get(url_conta + "subrubros", axiosConfig);
		var resp = {
			type: ADD_SUBRUBRO,
			payload: datos.data,
			datos_send,
			datos_lista
		};
		return resp;
	} catch (error) {
		throw new ConnectionError(error)
	}
};

export const addTax = async (datos_send) => {
	try {
		var axiosConfig = {
			headers: {
				Authorization: "Bearer " + localStorage.getItem("BelieveToken"),
			},
		};
		const datos = await axios.post(url_conta + "taxes", datos_send, axiosConfig);
		
		if (datos.data.error && datos.data.hasOwnProperty("sale") && datos.data.sale == 1) await sale();
		const datos_lista = await axios.get(url_conta + "taxes", axiosConfig);
		var resp = {
			type: ADD_TAX,
			payload: datos_lista.data.data,
			datos_send,
		};
		return resp;
	} catch (error) {
		throw new ConnectionError(error)
	}
};

export const updateSource = async (datos_send) => {
	try {
		var axiosConfig = {
			headers: {
				Authorization: "Bearer " + localStorage.getItem("BelieveToken"),
			},
		};
		const datos = await axios.put(url_conta + "source/"+datos_send.id, datos_send, axiosConfig);
		
		if (datos.data.error && datos.data.hasOwnProperty("sale") && datos.data.sale == 1) await sale();
		var resp = {
			type: UPDATE_SOURCE,
			payload: datos.data,
			datos_send,
		};
		return resp;
	} catch (error) {
		throw new ConnectionError(error)
	}
};

export const updateClient = async (datos_send) => {
	try {
		var axiosConfig = {
			headers: {
				Authorization: "Bearer " + localStorage.getItem("BelieveToken"),
			},
		};
		const datos = await axios.put(url_conta + "clients/"+datos_send.id, datos_send, axiosConfig);
		
		if (datos.data.error && datos.data.hasOwnProperty("sale") && datos.data.sale == 1) await sale();
		var resp = {
			type: UPDATE_CLIENT,
			payload: datos.data,
			datos_send,
		};
		return resp;
	} catch (error) {
		throw new ConnectionError(error)
	}
};

export const updateSupplier = async (datos_send) => {
	try {
		var axiosConfig = {
			headers: {
				Authorization: "Bearer " + localStorage.getItem("BelieveToken"),
			},
		};
		const datos = await axios.put(url_conta + "suppliers/" + datos_send.id, datos_send, axiosConfig);
		
		if (datos.data.error && datos.data.hasOwnProperty("sale") && datos.data.sale == 1) await sale();
		var resp = {
			type: UPDATE_SUPPLIER,
			payload: datos.data,
			datos_send,
		};
		return resp;
	} catch (error) {
		throw new ConnectionError(error)
	}
};

export const updateItem = async (datos_send) => {
	try {
		var axiosConfig = {
			headers: {
				Authorization: "Bearer " + localStorage.getItem("BelieveToken"),
			},
		};
		const datos = await axios.put(url_conta + "products/" + datos_send.id, datos_send, axiosConfig);
		
		if (datos.data.error && datos.data.hasOwnProperty("sale") && datos.data.sale == 1) await sale();
		const datos_lista = await axios.get(url_conta + "products", axiosConfig);
		var resp = {
			type: UPDATE_ITEM,
			payload: datos.data,
			datos_lista,
		};
		return resp;
	} catch (error) {
		throw new ConnectionError(error)
	}
};

export const updateUsuario = async (datos_send) => {
	try {
		var axiosConfig = {
			headers: {
				Authorization: "Bearer " + localStorage.getItem("BelieveToken"),
			},
		};
		const datos = await axios.put(url_conta + "usuarios/" + datos_send.id, datos_send, axiosConfig);
		if (datos.data.error && datos.data.hasOwnProperty("sale") && datos.data.sale == 1) await sale();
		const datos_lista = await axios.get(url_conta + "usuarios", axiosConfig);
		var resp = {
			type: UPDATE_USUARIO,
			payload: datos_lista.data.data,
			datos_send,
		};
		return resp;
	} catch (error) {
		throw new ConnectionError(error)
	}
};

export const updateMedio = async (datos_send) => {
	try {
		var axiosConfig = {
			headers: {
				Authorization: "Bearer " + localStorage.getItem("BelieveToken"),
			},
		};
		const datos = await axios.put(url_conta + "medios/" + datos_send.id, datos_send, axiosConfig);
		
		if (datos.data.error && datos.data.hasOwnProperty("sale") && datos.data.sale == 1) await sale();
		var resp = {
			type: UPDATE_MEDIO,
			payload: datos.data,
			datos_send,
		};
		return resp;
	} catch (error) {
		throw new ConnectionError(error)
	}
};

export const updateMoneda = async (datos_send) => {
	try {
		var axiosConfig = {
			headers: {
				Authorization: "Bearer " + localStorage.getItem("BelieveToken"),
			},
		};
		const datos = await axios.put(url_conta + "monedas/" + datos_send.id, datos_send, axiosConfig);
		
		if (datos.data.error && datos.data.hasOwnProperty("sale") && datos.data.sale == 1) await sale();
		var resp = {
			type: UPDATE_MONEDA,
			payload: datos.data,
			datos_send,
		};
		return resp;
	} catch (error) {
		throw new ConnectionError(error)
	}
};

export const updateRubro = async (datos_send) => {
	try {
		var axiosConfig = {
			headers: {
				Authorization: "Bearer " + localStorage.getItem("BelieveToken"),
			},
		};
		const datos = await axios.put(url_conta + "rubros/" + datos_send.id, datos_send, axiosConfig);
		
		if (datos.data.error && datos.data.hasOwnProperty("sale") && datos.data.sale == 1) await sale();
		const datos_lista = await axios.get(url_conta + "rubros", axiosConfig);
		var resp = {
			type: UPDATE_RUBRO,
			payload: datos.data,
			datos_send,
			datos_lista
		};
		return resp;
	} catch (error) {
		throw new ConnectionError(error)
	}
};

export const updateSubRubro = async (datos_send) => {
	try {
		var axiosConfig = {
			headers: {
				Authorization: "Bearer " + localStorage.getItem("BelieveToken"),
			},
		};
		const datos = await axios.put(url_conta + "subrubros/" + datos_send.id, datos_send, axiosConfig);
		
		if (datos.data.error && datos.data.hasOwnProperty("sale") && datos.data.sale == 1) await sale();
		const datos_lista = await axios.get(url_conta + "subrubros", axiosConfig);
		var resp = {
			type: UPDATE_SUBRUBRO,
			payload: datos.data,
			datos_send,
			datos_lista
		};
		return resp;
	} catch (error) {
		throw new ConnectionError(error)
	}
};

export const updateTax = async (datos_send) => {
	try {
		var axiosConfig = {
			headers: {
				Authorization: "Bearer " + localStorage.getItem("BelieveToken"),
			},
		};
		const datos = await axios.put(url_conta + "taxes/" + datos_send.id, datos_send, axiosConfig);
		
		if (datos.data.error && datos.data.hasOwnProperty("sale") && datos.data.sale == 1) await sale();
		const datos_lista = await axios.get(url_conta + "taxes", axiosConfig);
		var resp = {
			type: UPDATE_TAX,
			payload: datos_lista.data.data,
			datos_send,
		};
		return resp;
	} catch (error) {
		throw new ConnectionError(error)
	}
};

export const delSource = async (id) => {
	try {
		var axiosConfig = {
			headers: {
				Authorization: "Bearer " + localStorage.getItem("BelieveToken"),
			},
		};
		const datos = await axios.delete(url_conta + "source/" + id,  axiosConfig);
		
		if (datos.data.error && datos.data.hasOwnProperty("sale") && datos.data.sale == 1) await sale();
		var resp = {
			type: DEL_SOURCE,
			payload: datos.data,
			id,
		};
		return resp;
	} catch (error) {
		throw new ConnectionError(error)
	}
};

export const delClient = async (id) => {
	try {
		var axiosConfig = {
			headers: {
				Authorization: "Bearer " + localStorage.getItem("BelieveToken"),
			},
		};
		const datos = await axios.delete(url_conta + "clients/" + id,  axiosConfig);
		
		if (datos.data.error && datos.data.hasOwnProperty("sale") && datos.data.sale == 1) await sale();
		var resp = {
			type: DEL_CLIENT,
			payload: datos.data,
			id,
		};
		return resp;
	} catch (error) {
		throw new ConnectionError(error)
	}
};

export const delSupplier = async (id) => {
	try {
		var axiosConfig = {
			headers: {
				Authorization: "Bearer " + localStorage.getItem("BelieveToken"),
			},
		};
		const datos = await axios.delete(url_conta + "suppliers/" + id,  axiosConfig);
		
		if (datos.data.error && datos.data.hasOwnProperty("sale") && datos.data.sale == 1) await sale();
		var resp = {
			type: DEL_SUPPLIER,
			payload: datos.data,
			id,
		};
		return resp;
	} catch (error) {
		throw new ConnectionError(error)
	}
};

export const delItem = async (id) => {
	try {
		var axiosConfig = {
			headers: {
				Authorization: "Bearer " + localStorage.getItem("BelieveToken"),
			},
		};
		const datos = await axios.delete(url_conta + "products/" + id,  axiosConfig);
		
		if (datos.data.error && datos.data.hasOwnProperty("sale") && datos.data.sale == 1) await sale();
		const datos_lista = await axios.get(url_conta + "products", axiosConfig);
		var resp = {
			type: DEL_ITEM,
			payload: datos.data,
			id,
			datos_lista
		};
		return resp;
	} catch (error) {
		throw new ConnectionError(error)
	}
};

export const delMedio = async (id) => {
	try {
		var axiosConfig = {
			headers: {
				Authorization: "Bearer " + localStorage.getItem("BelieveToken"),
			},
		};
		const datos = await axios.delete(url_conta + "medios/" + id,  axiosConfig);
		
		if (datos.data.error && datos.data.hasOwnProperty("sale") && datos.data.sale == 1) await sale();
		var resp = {
			type: DEL_MEDIO,
			payload: datos.data,
			id,
		};
		return resp;
	} catch (error) {
		throw new ConnectionError(error)
	}
};

export const delMoneda = async (id) => {
	try {
		var axiosConfig = {
			headers: {
				Authorization: "Bearer " + localStorage.getItem("BelieveToken"),
			},
		};
		const datos = await axios.delete(url_conta + "monedas/" + id,  axiosConfig);
		
		if (datos.data.error && datos.data.hasOwnProperty("sale") && datos.data.sale == 1) await sale();
		var resp = {
			type: DEL_MONEDA,
			payload: datos.data,
			id,
		};
		return resp;
	} catch (error) {
		throw new ConnectionError(error)
	}
};

export const delRubro = async (id) => {
	try {
		var axiosConfig = {
			headers: {
				Authorization: "Bearer " + localStorage.getItem("BelieveToken"),
			},
		};
		const datos = await axios.delete(url_conta + "rubros/" + id,  axiosConfig);
		
		if (datos.data.error && datos.data.hasOwnProperty("sale") && datos.data.sale == 1) await sale();
		const datos_lista = await axios.get(url_conta + "rubros", axiosConfig);
		var resp = {
			type: DEL_RUBRO,
			payload: datos.data,
			id,
			datos_lista
		};
		return resp;
	} catch (error) {
		throw new ConnectionError(error)
	}
};

export const delSubRubro = async (id) => {
	try {
		var axiosConfig = {
			headers: {
				Authorization: "Bearer " + localStorage.getItem("BelieveToken"),
			},
		};
		const datos = await axios.delete(url_conta + "subrubros/" + id,  axiosConfig);
		
		if (datos.data.error && datos.data.hasOwnProperty("sale") && datos.data.sale == 1) await sale();
		const datos_lista = await axios.get(url_conta + "subrubros", axiosConfig);
		var resp = {
			type: DEL_SUBRUBRO,
			payload: datos.data,
			id,
			datos_lista
		};
		return resp;
	} catch (error) {
		throw new ConnectionError(error)
	}
};

export const delTax = async (id) => {
	try {
		var axiosConfig = {
			headers: {
				Authorization: "Bearer " + localStorage.getItem("BelieveToken"),
			},
		};
		const datos = await axios.delete(url_conta + "taxes/" + id,  axiosConfig);
		
		if (datos.data.error && datos.data.hasOwnProperty("sale") && datos.data.sale == 1) await sale();
		const datos_lista = await axios.get(url_conta + "taxes", axiosConfig);
		var resp = {
			type: DEL_TAX,
			payload: datos_lista.data.data,
			id,
		};
		return resp;
	} catch (error) {
		throw new ConnectionError(error)
	}
};

export const updateDato = async (datos_send) => {
	try {
		var axiosConfig = {
			headers: {
				Authorization: "Bearer " + localStorage.getItem("BelieveToken"),
			},
		};
		const datos = await axios.put(url_conta + "campo/" + datos_send.id, datos_send, axiosConfig);
		
		if (datos.data.error && datos.data.hasOwnProperty("sale") && datos.data.sale == 1) await sale();
		var resp = {
			type: UPDATE_DATO,
			payload: datos.data,
			datos_send,
		};
		return resp;
	} catch (error) {
		throw new ConnectionError(error)
	}
};

export const updatePrice = async (datos_send) => {
	try {
		var axiosConfig = {
			headers: {
				Authorization: "Bearer " + localStorage.getItem("BelieveToken"),
			},
		};
		const datos = await axios.put(url_rooms_prices + "/" + datos_send.id, datos_send, axiosConfig);
		
		if (datos.data.error && datos.data.hasOwnProperty("sale") && datos.data.sale == 1) await sale();
		var resp = {
			type: UPDATE_PRICE,
			payload: datos.data,
			datos_send,
		};
		return resp;
	} catch (error) {
		throw new ConnectionError(error)
	}
};

export const getRoomsPrices = async () => {
	try {
		var axiosConfig = {
			headers: {
				Authorization: "Bearer " + localStorage.getItem("BelieveToken"),
			},
		};

		const datos = await axios.get(url_rooms_prices , axiosConfig);

		if (datos.data.error && datos.data.hasOwnProperty("sale") && datos.data.sale == 1) await sale();
		
		var resp = {
			type: GET_ROOMS_PRICES,
			payload: datos.data.data,
		};
		//
		return resp;
	} catch (error) {
		throw new ConnectionError(error)
	}
};

export const getSeasons = async () => {
	try {
		var axiosConfig = {
			headers: {
				Authorization: "Bearer " + localStorage.getItem("BelieveToken"),
			},
		}; 
		const datos = await axios.get(url_seasons, axiosConfig);
		if (datos.data.error && datos.data.hasOwnProperty("sale") && datos.data.sale == 1) await sale();
		
		var resp = {
			type: GET_SEASONS,
			payload: datos.data.data,
			
		};
		return resp;
	} catch (error) {
		throw new ConnectionError(error)
	}
};

export const updateSeasons = async (data) => {
	try {
		var axiosConfig = {
			headers: {
				Authorization: "Bearer " + localStorage.getItem("BelieveToken"),
			},
		};
		const datos = await axios.post(url_seasons, data,axiosConfig);
		if (datos.data.error && datos.data.hasOwnProperty("sale") && datos.data.sale == 1) await sale();
		
		var resp = {
			type: UPDATE_SEASONS,
			payload:data
		};

		return resp;
	} catch (error) {
		throw new ConnectionError(error)
	}
};

export const getCustomItems = async () => {
	try {
		var axiosConfig = {
			headers: {
				Authorization: "Bearer " + localStorage.getItem("BelieveToken"),
			},
		};
		const datos = await axios.get(url_customizer_items, axiosConfig);
		if (datos.data.error && datos.data.hasOwnProperty("sale") && datos.data.sale == 1) await sale();
		const datos_s = await axios.get(url_seasons, axiosConfig);

		var resp = {
			type: GET_CUSTOM_ITEMS,
			payload: datos.data.data,
			seasons: datos_s.data.data,
		};
		return resp;
	} catch (error) {
		throw new ConnectionError(error)
	}
};

export const getRooms = async () => {
	try {
		
		var axiosConfig = {
			headers: {
				Authorization: "Bearer " + localStorage.getItem("BelieveToken"),
			},
		};

		const datos = await axios.get(url_rooms, axiosConfig);

		if (datos.data.error && datos.data.hasOwnProperty("sale") && datos.data.sale == 1) await sale();
		
		var resp = {
			type: GET_ROOMS,
			payload: datos.data.data,
		};
		//
		return resp;
	} catch (error) {
		throw new ConnectionError(error)
	}
};

export const getEnquiries = async () => {
	try {
		var axiosConfig = {
			headers: {
				Authorization: "Bearer " + localStorage.getItem("BelieveToken"),
			},
		};

		const datos = await axios.get(url_enquiries+"/0/100", axiosConfig);

		if (datos.data.error && datos.data.hasOwnProperty("sale") && datos.data.sale == 1) await sale();
		
		var resp = {
			type: GET_ENQUIRIES,
			payload: datos.data.data,
		};
		//
		return resp;
	} catch (error) {
		throw new ConnectionError(error)
	}
};

export const getActivityFormats = async () =>{
	try {
		var axiosConfig = {
			headers: {
				Authorization: "Bearer " + localStorage.getItem("BelieveToken"),
			},
		};
		const datos = await axios.get(url_conta+"activity_format", axiosConfig);
		if (datos.data.error && datos.data.hasOwnProperty("sale") && datos.data.sale == 1) await sale();
		var resp = {
			type: GET_ACTIVITY_FORMATS,
			payload: datos.data.data,
		};
		return resp;
	} catch (error) {
		throw new ConnectionError(error)
	}
}

export const addActivityFormats = async (_data) =>{
	try {
		var axiosConfig = {
			headers: {
				Authorization: "Bearer " + localStorage.getItem("BelieveToken"),
			},
		};
		const datos_s = await axios.post(url_conta+"activity_format",_data, axiosConfig);
		const datos = await axios.get(url_conta+"activity_format", axiosConfig);
		if (datos.data.error && datos.data.hasOwnProperty("sale") && datos.data.sale == 1) await sale();
		var resp = {
			type: ADD_ACTIVITY_FORMATS,
			payload: datos.data.data,
		};
		return resp;
	} catch (error) {
		throw new ConnectionError(error)
	}
}
export const updateActivityFormats = async (_data) =>{
	try {
		var axiosConfig = {
			headers: {
				Authorization: "Bearer " + localStorage.getItem("BelieveToken"),
			},
		};
		const datos_s = await axios.put(url_conta+"activity_format/"+_data.id,_data, axiosConfig);
		const datos = await axios.get(url_conta+"activity_format", axiosConfig);
		if (datos.data.error && datos.data.hasOwnProperty("sale") && datos.data.sale == 1) await sale();
		var resp = {
			type: UPDATE_ACTIVITY_FORMATS,
			payload: datos.data.data,
		};
		return resp;
	} catch (error) {
		throw new ConnectionError(error)
	}
}
export const delActivityFormats = async (_id) =>{
	try {
		var axiosConfig = {
			headers: {
				Authorization: "Bearer " + localStorage.getItem("BelieveToken"),
			},
		};
		const datos_s = await axios.put(url_conta+"activity_format/"+_id, axiosConfig);
		const datos = await axios.get(url_conta+"activity_format", axiosConfig);
		if (datos.data.error && datos.data.hasOwnProperty("sale") && datos.data.sale == 1) await sale();
		var resp = {
			type: DEL_ACTIVITY_FORMATS,
			payload: datos.data.data,
		};
		return resp;
	} catch (error) {
		throw new ConnectionError(error)
	}
}

export const getActivities = async () =>{
	try {
		var axiosConfig = {
			headers: {
				Authorization: "Bearer " + localStorage.getItem("BelieveToken"),
			},
		};
		const datos = await axios.get(url_conta+"activities", axiosConfig);
		if (datos.data.error && datos.data.hasOwnProperty("sale") && datos.data.sale == 1) await sale();
		var resp = {
			type: GET_ACTIVITIES,
			payload: datos.data.data,
		};
		return resp;
	} catch (error) {
		throw new ConnectionError(error)
	}
}

export const addActivities = async (_data) =>{
	try {
		var axiosConfig = {
			headers: {
				Authorization: "Bearer " + localStorage.getItem("BelieveToken"),
			},
		};
		const datos_s = await axios.post(url_conta+"activities",_data, axiosConfig);
		const datos = await axios.get(url_conta+"activities", axiosConfig);
		if (datos.data.error && datos.data.hasOwnProperty("sale") && datos.data.sale == 1) await sale();
		var resp = {
			type: ADD_ACTIVITIES,
			payload: datos.data.data,
		};
		return resp;
	} catch (error) {
		throw new ConnectionError(error)
	}
}
export const updateActivities = async (_data) =>{
	try {
		var axiosConfig = {
			headers: {
				Authorization: "Bearer " + localStorage.getItem("BelieveToken"),
			},
		};
		const datos_s = await axios.put(url_conta+"activities/"+_data.id,_data, axiosConfig);
		const datos = await axios.get(url_conta+"activities", axiosConfig);
		if (datos.data.error && datos.data.hasOwnProperty("sale") && datos.data.sale == 1) await sale();
		var resp = {
			type: UPDATE_ACTIVITIES,
			payload: datos.data.data,
		};
		return resp;
	} catch (error) {
		throw new ConnectionError(error)
	}
}
export const delActivities = async (_id) =>{
	try {
		var axiosConfig = {
			headers: {
				Authorization: "Bearer " + localStorage.getItem("BelieveToken"),
			},
		};
		const datos_s = await axios.put(url_conta+"activities/"+_id, axiosConfig);
		const datos = await axios.get(url_conta+"activities", axiosConfig);
		if (datos.data.error && datos.data.hasOwnProperty("sale") && datos.data.sale == 1) await sale();
		var resp = {
			type: DEL_ACTIVITIES,
			payload: datos.data.data,
		};
		return resp;
	} catch (error) {
		throw new ConnectionError(error)
	}
}

export const getInstructors = async (_cat,_term) =>{
	try {
		const datos = await getInstructorsList(_cat, _term);
		var resp = {
			type: GET_INSTRUCTORS,
			payload: datos.data.data,
		};
		return resp;
	} catch (error) {
		throw new ConnectionError(error)
	}
}

export const addInstructors = async (_data,_cat,_term) =>{
	try {
		var axiosConfig = {
			headers: {
				Authorization: "Bearer " + localStorage.getItem("BelieveToken"),
			},
		};
		const datos_s = await axios.post(url_conta+"instructors",_data, axiosConfig);
		const datos = await axios.get(url_conta+"instructors/"+_cat+"/"+_term, axiosConfig);
		if (datos.data.error && datos.data.hasOwnProperty("sale") && datos.data.sale == 1) await sale();
		var resp = {
			type: GET_INSTRUCTORS,
			payload: datos.data.data,
		};
		return resp;
	} catch (error) {
		throw new ConnectionError(error)
	}
}
export const updateInstructors = async (_data,_cat,_term) =>{
	try {
		var axiosConfig = {
			headers: {
				Authorization: "Bearer " + localStorage.getItem("BelieveToken"),
			},
		};
		const datos_s = await axios.put(url_conta+"instructors/"+_data.id,_data, axiosConfig);
		const datos = await axios.get(url_conta+"instructors/"+_cat+"/"+_term, axiosConfig);
		if (datos.data.error && datos.data.hasOwnProperty("sale") && datos.data.sale == 1) await sale();
		var resp = {
			type: GET_INSTRUCTORS,
			payload: datos.data.data,
		};
		return resp;
	} catch (error) {
		throw new ConnectionError(error)
	}
}
export const delInstructors = async (_id,_cat,_term) =>{
	try {
		var axiosConfig = {
			headers: {
				Authorization: "Bearer " + localStorage.getItem("BelieveToken"),
			},
		};
		const datos_s = await axios.delete(url_conta+"instructors/"+_id, axiosConfig);
		const datos = await axios.get(url_conta+"instructors/"+_cat+"/"+_term, axiosConfig);
		if (datos.data.error && datos.data.hasOwnProperty("sale") && datos.data.sale == 1) await sale();
		var resp = {
			type: GET_INSTRUCTORS,
			payload: datos.data.data,
		};
		return resp;
	} catch (error) {
		throw new ConnectionError(error)
	}
}

export const getAssets = async (_id_hotel) =>{
	try {
		var axiosConfig = {
			headers: {
				Authorization: "Bearer " + localStorage.getItem("BelieveToken"),
			},
		};
		const datos = await axios.get(url_conta+"assets/"+_id_hotel, axiosConfig);
		if (datos.data.error && datos.data.hasOwnProperty("sale") && datos.data.sale == 1) await sale();
		var resp = {
			type: GET_ASSET,
			payload: datos.data.data,
		};
		return resp;
	} catch (error) {
		throw new ConnectionError(error)
	}
}

export const addAsset = async (_data,_cat,_term) =>{
	try {
		var axiosConfig = {
			headers: {
				Authorization: "Bearer " + localStorage.getItem("BelieveToken"),
			},
		};
		const datos_s = await axios.post(url_conta+"assets",_data, axiosConfig);
		const datos = await axios.get(url_conta+"assets/"+_data.id_hotel, axiosConfig);
		if (datos.data.error && datos.data.hasOwnProperty("sale") && datos.data.sale == 1) await sale();
		var resp = {
			type: GET_ASSET,
			payload: datos.data.data,
		};
		return resp;
	} catch (error) {
		throw new ConnectionError(error)
	}
}
export const updateAsset = async (_data,_cat,_term) =>{
	try {
		var axiosConfig = {
			headers: {
				Authorization: "Bearer " + localStorage.getItem("BelieveToken"),
			},
		};
		const datos_s = await axios.put(url_conta+"assets/"+_data.id,_data, axiosConfig);
		const datos = await axios.get(url_conta+"assets/"+_data.id_hotel, axiosConfig);
		if (datos.data.error && datos.data.hasOwnProperty("sale") && datos.data.sale == 1) await sale();
		var resp = {
			type: GET_ASSET,
			payload: datos.data.data,
		};
		return resp;
	} catch (error) {
		throw new ConnectionError(error)
	}
}
export const delAsset = async (_id,_cat,_term) =>{
	try {
		var axiosConfig = {
			headers: {
				Authorization: "Bearer " + localStorage.getItem("BelieveToken"),
			},
		};
		const datos_s = await axios.delete(url_conta+"assets/"+_id, axiosConfig);
		const datos = await axios.get(url_conta+"assets", axiosConfig);
		if (datos.data.error && datos.data.hasOwnProperty("sale") && datos.data.sale == 1) await sale();
		var resp = {
			type: DEL_ASSET,
			payload: datos.data.data,
		};
		return resp;
	} catch (error) {
		throw new ConnectionError(error)
	}
}

export const getAssetsTypes = async () =>{
	try {
		var axiosConfig = {
			headers: {
				Authorization: "Bearer " + localStorage.getItem("BelieveToken"),
			},
		};
		const datos = await axios.get(url_conta+"assets_tipos", axiosConfig);
		if (datos.data.error && datos.data.hasOwnProperty("sale") && datos.data.sale == 1) await sale();
		var resp = {
			type: GET_ASSETS_TYPE,
			payload: datos.data.data,
		};
		return resp;
	} catch (error) {
		throw new ConnectionError(error)
	}
}

export const addAssetsTypes = async (_data) =>{
	try {
		var axiosConfig = {
			headers: {
				Authorization: "Bearer " + localStorage.getItem("BelieveToken"),
			},
		};
		const datos_s = await axios.post(url_conta+"assets_tipo",_data, axiosConfig);
		const datos = await axios.get(url_conta+"assets_tipos", axiosConfig);
		if (datos.data.error && datos.data.hasOwnProperty("sale") && datos.data.sale == 1) await sale();
		var resp = {
			type: GET_ASSETS_TYPE,
			payload: datos.data.data,
		};
		return resp;
	} catch (error) {
		throw new ConnectionError(error)
	}
}
export const updateAssetsTypes = async (_data) =>{
	try {
		var axiosConfig = {
			headers: {
				Authorization: "Bearer " + localStorage.getItem("BelieveToken"),
			},
		};
		const datos_s = await axios.put(url_conta+"assets_tipo/"+_data.id,_data, axiosConfig);
		const datos = await axios.get(url_conta+"assets_tipos", axiosConfig);
		if (datos.data.error && datos.data.hasOwnProperty("sale") && datos.data.sale == 1) await sale();
		var resp = {
			type: GET_ASSETS_TYPE,
			payload: datos.data.data,
		};
		return resp;
	} catch (error) {
		throw new ConnectionError(error)
	}
}
export const delAssetsTypes = async (_id) =>{
	try {
		var axiosConfig = {
			headers: {
				Authorization: "Bearer " + localStorage.getItem("BelieveToken"),
			},
		};
		const datos_s = await axios.delete(url_conta+"assets_tipo/"+_id, axiosConfig);
		const datos = await axios.get(url_conta+"assets_tipos", axiosConfig);
		if (datos.data.error && datos.data.hasOwnProperty("sale") && datos.data.sale == 1) await sale();
		var resp = {
			type: DEL_ASSETS_TYPE,
			payload: datos.data.data,
		};
		return resp;
	} catch (error) {
		throw new ConnectionError(error)
	}
}

export const getReceipts = async (_desde,_hasta) =>{
	try {
		var axiosConfig = {
			headers: {
				Authorization: "Bearer " + localStorage.getItem("BelieveToken"),
			},
		};
		const datos = await axios.get(url_conta+"loyverse_receipts/"+_desde+"/"+_hasta, axiosConfig);
		var resp = {
			type: GET_RECEIPTS,
			payload: datos.data.data,
		};
		return resp;
	} catch (error) {
		throw new ConnectionError(error)
	}
}

export const sendLogin = async (data) => {
	try {
		let request = "";
		request = await axios.post(url_auth, data);
		let t = request.data.t;
		if (!request.data.err && t && t != "") {
			const u = {
				id: request.data.user.ui,
				user: request.data.user.user,
				nombre: request.data.user.nombre,
				apellido: request.data.user.apellido,
				rol: request.data.user.rol,
				tipo: request.data.user.tipo,
				hotel_def: request.data.user.hotel_def,
			};
			
			await localStorage.setItem("BelieveToken", t);
			await localStorage.setItem("isAuthenticate", true);
			return {
				type: LOG_USER,
				payload: {u,menu:request.data.menu, unidades:request.data.unidades},
			};
		} else {
			return {
				type: SEND_USER_MSJ,
				msj: request.data.msj,
				msj_tipo: "alert-danger",
			};
		}
	} catch (error) {
		return {
			type: SEND_USER_MSJ,
			msj: error,
			msj_tipo: "alert-danger",
		};
	}
};

export const checkLogin = async () => {
	try {

		var axiosConfig = {
			headers: {
				Authorization: "Bearer " + localStorage.getItem("BelieveToken"),
			},
		};

		var request = await axios.post(url_auth + "valida_token", {},axiosConfig);		
		if (!request.data.err) {
			return {
				type: CHK_USER,
				payload:{u:request.data.user, menu:request.data.menu, unidades:request.data.unidades}
			};
		} else {
			await sale()
			return {
				type: CHK_USER,
			};
		}
	} catch (error) {
		await sale()
		return {
			type: SEND_USER_MSJ,
			msj: error,
			msj_tipo: "alert-danger",
		};
	}
};

export const sendUserMsj = (msj, tipo) => {
	return {
		type: SEND_USER_MSJ,
		msj: msj,
		msj_tipo: tipo,
	};
};

export const signOut = async () => {
	
	try {
		await localStorage.removeItem("BelieveToken");
		await localStorage.removeItem("isAuthenticate");
		return {
			type: LOGOUT_USER,
		};
	} catch (err) {
		
		return {
			type: SEND_USER_MSJ,
			resp: 0,
			msj: err,
			tipo: 3,
			msj_tipo: "alert-danger",
		};
	}
};

export const  sale = async () => {
	try {
		await localStorage.removeItem("BelieveToken");
		await localStorage.removeItem("isAuthenticate");
		return {
			type: LOGOUT_USER,
		};
	} catch (err) {
		
		return {
			type: SEND_USER_MSJ,
			resp: 0,
			msj: err,
			tipo: 3,
			msj_tipo: "alert-danger",
		};
	}
};


